module.exports = __webpack_public_path__ + "img/security.a9117055.svg";